// Material Dashboard 2 PRO React base styles
import typography from "assets/theme-dark/base/typography";

// Material Dashboard 2 PRO React helper functions
import pxToRem from "assets/theme-dark/functions/pxToRem";

const { size } = typography;

const dialogTitle = {
  styleOverrides: {
    root: {
      padding: `${pxToRem(16)} ${pxToRem(24)}`,
      fontSize: size.xl,
      fontWeight: 600,
      backgroundColor: "#2a2a2a",
      borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
      color: "#ffffff",
    },
  },
};

export default dialogTitle;
